import SalesLogs from './SalesLogs'

export default SalesLogs



// WEBPACK FOOTER //
// ./src/components/Reports/Shellfish/SalesLogs/index.js